module.exports = __webpack_public_path__ + "img/ic_search_line.0324a91e.svg";